import { isAppInstalled } from "react-native-send-intent"
import { AppRecord } from "../types"

const computeAppInstalled = async (app: AppRecord): Promise<AppRecord> => ({
  ...app,
  is_installed: app.package_name ? await isAppInstalled(app.package_name) : false,
})

/** Takes list of app records and response of getApps query and returns the app records with icons injected */
const computeInstallStatus = async (apps: AppRecord[] = []): Promise<AppRecord[]> => {
  return await Promise.all(apps.map(computeAppInstalled))
}

export default computeInstallStatus
